import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { Page } from '@/components/page';
import { LoadingScreenSpinner } from '@/components/loading-screen-spinner';

export function Join() {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const { planId } = useParams();

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (keycloak.authenticated) {
      navigate(`/purchase-plan/${planId}`);
    } else {
      navigate(`/register/${planId}`);
    }
  }, [keycloak.authenticated, initialized, navigate, planId]);

  return (
    <Page title="Joining...">
      <div className="flex justify-center items-center min-h-screen">
        <LoadingScreenSpinner />
      </div>
    </Page>
  );
}
